import {Routes} from '@angular/router';
import {EducationPageComponent} from './education-page.component';
import {EcfmgScreenComponent} from './steps/premedical/ecfmg/ecfmg-screen.component';
import {PremedicalEducationScreenComponent} from './steps/premedical/premedical/premedical-screen.component';
import {MedicalEducationScreenComponent} from './steps/medical/medical-education-screen.component';
import {OtherEducationScreenComponent} from './steps/other/other-education-screen.component';
import {FellowshipOrPreceptorshipScreenComponent} from './steps/fellowshipOrPreceptorship/fellowship-or-preceptorship-screen.component';
import {InternshipScreenComponent} from './steps/internship/internship-screen.component';
import {ResidencyScreenComponent} from './steps/residency/residency-screen.component';
import {InternshipScreensManager} from './steps/internship/internship-screens-manager.service';
import {ResidencyScreensManager} from './steps/residency/residency-screens-manager.service';
import {FellowshipOrPreceptorshipScreensManager} from './steps/fellowshipOrPreceptorship/fellowship-or-preceptorship-screens-manager.service';
import {OtherEducationScreensManager} from './steps/other/other-education-screens-manager.service';
import {
    PremedicalEducationScreensManager,
    PremedicalEducationScreens
} from './steps/premedical/premedical-education-screens-manager.service';
import {CompletedMedicalSchoolInUsaScreenComponent} from './steps/premedical/question/completed-medical-school-in-usa-screen.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'education',
    component: EducationPageComponent,
    children: [
        {
            path: '',
            children: [
                {path: '', redirectTo: 'completedMedicalSchoolInUsa', pathMatch: 'full'},
                {
                    path: 'completedMedicalSchoolInUsa',
                    component: CompletedMedicalSchoolInUsaScreenComponent,
                    data: {screen: {id: PremedicalEducationScreens.QUESTION}}
                },
                {
                    path: 'ecfmg',
                    component: EcfmgScreenComponent,
                    data: {screen: {id: PremedicalEducationScreens.ECFMG}}
                },
                {
                    path: 'premedical',
                    component: PremedicalEducationScreenComponent,
                    data: {screen: {id: PremedicalEducationScreens.PREMEDICAL}}
                }
            ],
            data: {step: {screensManager: PremedicalEducationScreensManager}}
        },
        {path: 'medical', component: MedicalEducationScreenComponent},
        {path: 'other', redirectTo: 'other/1', pathMatch: 'full'},
        {
            path: 'other/:index',
            component: OtherEducationScreenComponent,
            data: {step: {screensManager: OtherEducationScreensManager}}
        },
        {path: 'internship', redirectTo: 'internship/1', pathMatch: 'full'},
        {
            path: 'internship/:index',
            component: InternshipScreenComponent,
            data: {step: {screensManager: InternshipScreensManager}}
        },
        {path: 'residency', redirectTo: 'residency/1', pathMatch: 'full'},
        {
            path: 'residency/:index',
            component: ResidencyScreenComponent,
            data: {step: {screensManager: ResidencyScreensManager}}
        },
        {path: 'fellowshipOrPreceptorship', redirectTo: 'fellowshipOrPreceptorship/1', pathMatch: 'full'},
        {
            path: 'fellowshipOrPreceptorship/:index',
            component: FellowshipOrPreceptorshipScreenComponent,
            data: {step: {screensManager: FellowshipOrPreceptorshipScreensManager}}
        }
    ],
    data: {section: {title: 'Education'}, impersonationAllowed: true}
}];
export default routes;

export const screenManagers = [
    PremedicalEducationScreensManager,
    OtherEducationScreensManager,
    InternshipScreensManager,
    ResidencyScreensManager,
    FellowshipOrPreceptorshipScreensManager
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/education-page.routing.ts